import { Area } from 'react-easy-crop';

export const cropImage = async (
  imageSrc: string,
  pixelCrop: Area,
  padding?: number,
): Promise<string> => {
  const image = new window.Image();
  image.crossOrigin = 'anonymous';
  image.src = imageSrc;

  return new Promise((resolve, reject) => {
    image.onload = () => {
      try {
        const { x, y, width, height } = pixelCrop;

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('Canvas context not available');

        if (padding) {
          const cropHeight = height + padding * 2;
          const cropY = Math.max(0, y - padding);

          canvas.width = width;
          canvas.height = cropHeight;

          ctx.drawImage(image, x, cropY, width, cropHeight, 0, 0, width, cropHeight);
        } else {
          canvas.width = width;
          canvas.height = height;

          ctx.drawImage(image, x, y, width, height, 0, 0, width, height);
        }

        resolve(canvas.toDataURL('image/png'));
      } catch (error) {
        reject(error);
      }
    };
    image.onerror = () => reject(new Error('Failed to load image'));
  });
};
